import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useStores } from 'src/stores';

const AddressRoute = ({ isDevelop = false }) => {
  const params = useParams();
  const stores = useStores();
  const location = useLocation();

  if (isDevelop && location.pathname.split('/').splice(-1)[0] === 'dev') {
    stores.setDevelop(true);
  }

  return <Navigate to={`/address/${params.id}`} />;
};

export default AddressRoute;